import React from 'react';
import { useTranslation } from 'react-i18next';
import { type BiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';

import s from './CreatedWithBanner.scss';

interface Props {
  logo: React.ReactNode;
  titleText?: string;
  linkText?: string;
  linkHref?: string;
  linkOnClick?: () => void;
  linkBiData?: BiEvent;
  createdWithPrefix?: boolean;
}

const CreatedWithBanner: React.FC<Props> = ({
  logo,
  titleText,
  linkText,
  linkHref,
  linkOnClick,
  linkBiData,
  createdWithPrefix,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      {createdWithPrefix && (
        <div className={s['prefix']}>
          {t('deviation.details.createdWith.prefix')}
        </div>
      )}
      <div className={s['created-with']}>
        {logo}
        <div className={s['content']}>
          {titleText && <div className={s['title']}>{titleText}</div>}
          {linkText && (
            <TextButton
              className={s['link']}
              href={linkHref}
              onClick={linkOnClick}
              variant="approval-green"
              size="small"
              biData={linkBiData}
            >
              {linkText}
            </TextButton>
          )}
        </div>
      </div>
    </div>
  );
};
CreatedWithBanner.displayName = 'CreatedWithBanner';

export default CreatedWithBanner;
